
/*
 * ! @chakra-ui/vue v0.10.2 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { R as createStyledAttrsMixin } from './index-88b4bf19.js';
import { a as SNA, S as StringArray } from './props.types-26e3a1e7.js';
import { u as useInputStyle } from './input.styles-ae5c56e7.js';

var inputProps = {
  size: {
    type: SNA,
    default: 'md'
  },
  variant: {
    type: StringArray,
    default: 'outline'
  },
  as: {
    type: String,
    default: 'input'
  },
  _ariaLabel: String,
  _ariaDescribedby: String,
  isFullWidth: {
    type: Boolean,
    default: true
  },
  isReadOnly: Boolean,
  isDisabled: Boolean,
  isInvalid: Boolean,
  isRequired: Boolean,
  focusBorderColor: {
    type: String,
    default: 'blue.200'
  },
  errorBorderColor: {
    type: String,
    default: 'red.300'
  },
  value: {
    type: [String, Number],
    default: undefined
  }
};

/**
 * Hey! Welcome to @chakra-ui/vue Input
 *
 * CInput component is a component that is used to get user input in a text field
 *
 * It is usually used together with the FormControl to provide an accessible label, validation messages, etc.
 *
 * @see Docs     https://vue.chakra-ui.com/input
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CInput/CInput.js
 * @see WAI      https://www.w3.org/WAI/tutorials/forms/
 */
/**
 * CInput component
 *
 * Gets user input in a text field
 *
 * @extends CPseudoBox
 * @see Docs https://vue.chakra-ui.com/input
 */

var CInput = {
  name: 'CInput',
  mixins: [createStyledAttrsMixin('CInput')],
  inject: {
    $chakraColorMode: {
      default: 'light'
    },
    $chakraTheme: {
      default: function _default() {
        return {};
      }
    },
    $useFormControl: {
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: inputProps,
  computed: {
    formControl: function formControl() {
      if (!this.$useFormControl) {
        return {
          isReadOnly: this.isReadOnly,
          isDisabled: this.isDisabled,
          isInvalid: this.isInvalid,
          isRequired: this.isRequired
        };
      }

      return this.$useFormControl(this.$props);
    },
    inputStyles: function inputStyles() {
      return useInputStyle(Object.assign({}, this.$props, {
        theme: this.theme,
        colorMode: this.colorMode
      }));
    },
    componentStyles: function componentStyles() {
      return Object.assign({}, this.inputStyles, {
        fontFamily: 'body'
      });
    }
  },
  methods: {
    emitValue: function emitValue(event) {
      this.$emit('input', event.target.value, event);
      this.$emit('change', event);
    }
  },
  render: function render(h) {
    return h(this.as, {
      class: [this.className],
      domProps: {
        value: this.value
      },
      attrs: Object.assign({}, {
        'aria-readonly': this.isReadOnly,
        readonly: this.formControl.isReadOnly,
        disabled: this.formControl.isDisabled,
        'aria-disabled': this.formControl.isDisabled,
        'aria-invalid': this.formControl.isInvalid,
        required: this.formControl.isRequired,
        'aria-required': this.formControl.isRequired
      }, this.computedAttrs),
      on: Object.assign({}, this.computedListeners, {
        input: this.emitValue
      }),
      ref: 'input'
    }, this.$slots.default);
  }
};

export { CInput as C, inputProps as i };
